module.exports = __webpack_public_path__ + "ab6276a1b81ddf1bded92269ae446f3a.svg";